import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import TrackCard from '../../shared/TrackCard';

export default function PublicTracking() {
  const { code }              = useParams();
  const navigate              = useNavigate();
  const [items, setItems]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [query, setQuery]     = useState(code || '');

  useEffect(() => {
    if (!code) { setLoading(false); return; }
    axios.get(`/api/track/${code}`)
      .then((r) => setItems(r.data))
      .catch((err) => setError(err.response?.data?.message || 'Not found'))
      .finally(() => setLoading(false));
  }, [code]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) navigate(`/track/${query.trim()}`);
  };

  return (
    <div className="pt-page">
      {/* Header */}
      <div className="pt-header">
        <Link to="/" className="pt-back" aria-label="Back to home">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
        </Link>
        <div className="pt-header-brand">
          <span className="pt-brand-mark">D2D</span>
          <span className="pt-brand-name">Shipment Tracker</span>
        </div>
        <Link to="/login" className="pt-signin-link">Sign In</Link>
      </div>

      {/* Search bar */}
      <div className="pt-search-wrap">
        <form onSubmit={handleSearch} className="tk-search-form">
          <input
            className="input-field"
            placeholder="Enter tracking code or shipping mark…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button type="submit" className="btn btn-primary tk-search-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </button>
        </form>
      </div>

      <div className="page-content">
        {loading && (
          <div className="loading-center"><div className="spinner spinner-dark" /></div>
        )}

        {!loading && !code && (
          <div className="empty-state">
            <div className="icon">📦</div>
            <p style={{ fontWeight: 700, marginBottom: 6 }}>Track your package</p>
            <p>Enter your tracking code or D2D shipping mark above to see the latest status.</p>
          </div>
        )}

        {error && (
          <div className="empty-state">
            <div className="icon">🔍</div>
            <p style={{ fontWeight: 700, marginBottom: 6 }}>Nothing found</p>
            <p>No shipment matched <strong>"{code}"</strong>. Double-check the code and try again.</p>
            <div style={{ marginTop: 16 }}>
              <Link to="/register" className="btn btn-primary btn-sm">Create an account</Link>
            </div>
          </div>
        )}

        {!loading && !error && items.map((item, i) => (
          <TrackCard key={i} item={item} />
        ))}

        {!loading && !error && items.length === 0 && code && (
          <div className="empty-state">
            <div className="icon">📭</div>
            <p>No items found for <strong>"{code}"</strong>.</p>
          </div>
        )}
      </div>

      {/* Footer CTA */}
      {!loading && (
        <div className="pt-footer-cta">
          <p>Don't have an account?</p>
          <Link to="/register" className="btn btn-primary btn-sm">Create Free Account</Link>
        </div>
      )}
    </div>
  );
}
